import _moment from "moment";

_moment.locale("zh-cn");

export const moment = _moment;
